var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", { attrs: { title: "社員からの評判" } }),
        _vm._v(" "),
        _c("div", { staticClass: "grid-x align-justify" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "float-left boss-check-container" }, [
            _vm._v("\n        全\n        "),
            _c(
              "span",
              {
                staticClass: "boss-check-number",
                attrs: { "data-test": "displayed-count" },
              },
              [_vm._v(_vm._s(_vm.displayedCount))]
            ),
            _vm._v("件中\n        公開中の評判\n        "),
            _c(
              "span",
              {
                staticClass: "boss-check-number",
                attrs: { "data-test": "published-count" },
              },
              [_vm._v(_vm._s(_vm.publishedCount))]
            ),
            _vm._v(" 件（最大100件までご登録可能）\n        "),
            _vm.isDisplay
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.honneURL,
                      "data-test": "honne-link",
                      target: "_blank",
                    },
                  },
                  [
                    _vm._v(
                      "\n          ▶︎ 実際に公開中の画面はこちら\n        "
                    ),
                  ]
                )
              : _c(
                  "span",
                  {
                    staticClass: "boss-notice-text",
                    attrs: { "data-test": "hidden-display-honne" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.isDisplay === null
                          ? ""
                          : "公開中の評判がありません。ご登録・公開設定をお願いいたします。"
                      )
                    ),
                  ]
                ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "medium-3 cell" }, [
            _c(
              "button",
              {
                staticClass: "float-right boss-button boss-button-new",
                attrs: { "data-test": "register" },
                on: { click: _vm.onRegisterClick },
              },
              [
                _c("span", { staticClass: "boss-icon-new" }),
                _vm._v(" "),
                _c("span", { staticClass: "boss-button-new-text" }, [
                  _vm._v("新規作成する"),
                ]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "boss-table-wrap",
            attrs: {
              id: "real-intententions",
              "data-test": "real-intention-wrap",
            },
          },
          [
            _c("real-intentions", {
              ref: "RealIntentions",
              attrs: { "real-intentions": _vm.realIntentions },
              on: { "update-display": _vm.judgeIsDisplay, fetch: _vm.fetch },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "medium-12 cell" }, [
      _c("p", { staticClass: "margin-0" }, [
        _vm._v(
          "\n          「社員からの評判」として公開する内容を設定します。\n        "
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "boss-text" }, [
        _vm._v(
          "\n          「社員からの評判」は企業様管理画面でのみ登録・編集が可能です。営業担当者・制作担当者側では編集できません。\n          "
        ),
        _c(
          "a",
          {
            staticClass: "float-right",
            attrs: {
              "data-test": "format-download-link",
              target: "_blank",
              href: "/help/hyouban_format.xlsx",
            },
          },
          [
            _c("img", {
              staticClass: "pega-template-btn",
              attrs: {
                src: require("@/assets/images/icon-download-green.svg"),
                alt: "",
              },
            }),
            _vm._v("\n            ご回答シートのダウンロード\n          "),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("br"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }